import React from 'react';
import Box from '@material-ui/core/Box';

import styles from './ContactCard.module.css';

interface IContact {
  type: string
  icon: string
  text: string
}

interface IContactCard {
  header: string,
  contacts: IContact[],
}

const ContactCard = ({ header, contacts }: IContactCard) => (
  <Box
    padding={2}
    my={2.5}
    borderRadius={4}
    bgcolor="#F6F7F9"
    className={styles.contactBox}
  >
    <h3 className={styles.boxHeading}>
      {header}
    </h3>
    {contacts.map(({ icon, type, text }) => (
      <div key={text} className={styles.line}>
        <div className={styles.icon}>
          <img src={icon} alt={type} />
        </div>
        {type === 'email'
          ? (
            <a
              className={styles.text}
              href={`mailto:${text}`}
            >
              {text}
            </a>
          )
          : (
            <div className={styles.text}>
              {text}
            </div>
          )}
      </div>
    ))}
  </Box>
);

export default ContactCard;
